import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQueryWithHeaders } from '../api';

export interface SubmitFeedbackBody {
  rating: 'up' | 'down';
  feedback?: string;
}

export const useSubmitFeedback = () => {
  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  return useMutation({
    mutationFn: async ({
      clinicalNoteId,
      feedbackBody,
    }: {
      clinicalNoteId: string;
      feedbackBody: SubmitFeedbackBody;
    }) => {
      return makeAPIRequestReactQueryWithHeaders(
        `/videa-notes/${clinicalNoteId}/feedback`,
        {},
        {
          practice: currentPracticeId,
          org: currentOrganizationId,
        },
        'PATCH',
        {
          data: feedbackBody,
        },
      );
    },
  });
};
